import { useQuery } from '@tanstack/react-query';

import { fetchSnapshot } from '@/api/v4/snapshot-funnel.api';
import { QueryKey } from '@/config/query-client';

export const useSnapshotData = () => {
  return useQuery({
    queryKey: [QueryKey.Snapshot],
    queryFn: async () => fetchSnapshot(),
    staleTime: 1000 * 60 * 5,
  });
};
